import React, { useState } from "react";

import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import "../css/createTikTokDestination.css";
import {
    getTiktokAdvertisers,
    getTiktokOfflineAsync,
    isAuthTikTok,
} from "../helpers/destinations/createDestination";
import LoginButton from "./molecules/LoginButton";
import SwalAlertComp from "./SwalAlert";

const CreateTikTokDestination = ({
    form,
    setOfflineData,
    setTiktokAccess,
    setIsAuthData,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const language = useSelector((state) => state.languagesState.languages);

    const getAuthUrl = async () => {
        const isAuth = await isAuthTikTok();
        if (!isAuth?.status) return null;
        if (isAuth?.data?.authenticated) {
            if (form?.destinations === "ttoffline") {
                const res = await getTiktokOfflineAsync();
                if (res.status) {
                    setOfflineData(res?.data ?? "");
                    setTiktokAccess(true);
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: res?.message ?? "",
                        icon: "error",
                    });
                }
            } else {
                const res = await getTiktokAdvertisers();
                if (res.status) {
                    setIsAuthData(res?.data ?? "");
                    setTiktokAccess(true);
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: res?.message ?? "",
                        icon: "error",
                    });
                }
            }
            return null;
        }
        return isAuth?.data?.auth_url ?? null;
    };

    const getTiktokPixels = async (data) => {
        setIsLoading(true);
        try {
            if (form?.destinations === "ttoffline") {
                const res = await getTiktokOfflineAsync(data);
                if (res.status) {
                    setOfflineData(res?.data ?? "");
                    setTiktokAccess(true);
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: res?.message ?? "",
                        icon: "error",
                    });
                }
            } else {
                const res = await getTiktokAdvertisers(data);
                if (res.status) {
                    setIsAuthData(res?.data ?? "");
                    setTiktokAccess(true);
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: res?.message ?? "",
                        icon: "error",
                    });
                }
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="position-relative overflow-hidden z-1">
            <LoginButton
                code="tiktok"
                getAuthUrl={getAuthUrl}
                paramNames={["auth_code", "state"]}
                onSuccess={getTiktokPixels}
                dataTransform={(params) => ({
                    code: params.auth_code,
                    state: params.state,
                })}
                logoSrc="/assets/images/typeImages/tiktok-icon.png"
                buttonText={
                    language?.destination_modal?.create_with_tiktok ??
                    "Create with Tiktok"
                }
                isLoadingExternal={isLoading}
            />
        </div>
    );
};

export default CreateTikTokDestination;
